module.exports = __webpack_public_path__ + "img/close.ac6633b0.svg";